export const BOOKS = [
  {
    slug: "parable-parallels",
    number: "I",
    title: "Parable Parallels",
    subtitle: "Modern Christian Stories Inspired by The Bible and The Parables of Jesus",
    description:
      "The parables of Jesus, retold for the world we live in today. Modern stories of loss, mercy, forgiveness, and grace unfold in city streets, shelters, and hospital wards — each paired with the ancient parable that inspired it. Illustrated throughout.",
    price: "$32.95",
    formats: ["Kindle", "Paperback", "Audible"],
    cover: "https://m.media-amazon.com/images/I/61yFKvTILOL.jpg",
    fallbackCover: "https://images.pexels.com/photos/17028571/pexels-photo-17028571.jpeg?auto=compress&cs=tinysrgb&w=800",
    amazonUrl: "https://www.amazon.ca/dp/1997674084",
  },
  {
    slug: "faith-in-action",
    number: "II",
    title: "Faith in Action",
    subtitle: "Reclaiming Spirituality for a Just World",
    description:
      "Grounded in Liberation Theology and inspired by the life of St. Francis of Assisi, a stirring call to rediscover faith as a transformative force — moving beyond passive belief toward building a more just and compassionate world.",
    price: "$14.99",
    formats: ["Kindle", "Paperback"],
    cover: "https://m.media-amazon.com/images/I/41ZOJoBssiL.jpg",
    fallbackCover: "https://images.unsplash.com/photo-1534289855405-ab820a118fc1?auto=format&fit=crop&w=800&q=80",
    amazonUrl: "https://www.amazon.com/dp/0969277490",
  },
  {
    slug: "starry-night",
    number: "III",
    title: "Starry Night",
    subtitle: "A Collection of Faith and Wonder — Christian Christmas Stories",
    description:
      "Twenty-one luminous Christian Christmas stories that shimmer with hope, compassion, and the quiet miracle of faith. Warm seasonal magic meets deep spiritual meaning — a new December tradition.",
    price: "$14.95",
    formats: ["Kindle", "Paperback", "Audible"],
    cover: "https://m.media-amazon.com/images/I/41sxwqa2grL.jpg",
    fallbackCover: "https://images.unsplash.com/photo-1755541608494-5c02cf56e1f4?auto=format&fit=crop&w=800&q=80",
    amazonUrl: "https://www.amazon.com/dp/B0DPN95YQF",
  },
  {
    slug: "this-is-the-night",
    number: "IV",
    title: "This Is the Night",
    subtitle: "A Collection of Easter Short Stories for Christians",
    description:
      "The stories of Easter — retold, reimagined, and renewed for today. Rooted in Scripture and shaped by a lifetime of ministry, Holy Week comes alive with a resurrection hope that keeps happening, again and again.",
    price: "$15.99",
    formats: ["Kindle", "Paperback", "Audible"],
    cover: "https://m.media-amazon.com/images/I/41xRw3pDnBL.jpg",
    fallbackCover: "https://images.unsplash.com/photo-1755545730104-3cb4545282b1?auto=format&fit=crop&w=800&q=80",
    amazonUrl: "https://www.amazon.com/dp/1069326755",
  },
  {
    slug: "veni-creator-spiritus",
    number: "V",
    title: "Veni Creator Spiritus",
    subtitle: "Short Stories, Poems, and Reflections on Pentecost & Beyond",
    description:
      "Stories, poems, and reflections on Pentecost and beyond — moments of grace, doubt, and renewal among ordinary people touched by divine mystery, from a Cairo cathedral to a small-town soup kitchen.",
    price: "$15.99",
    formats: ["Kindle", "Paperback", "Audible"],
    cover: "https://m.media-amazon.com/images/I/41Pnuxc81HL.jpg",
    fallbackCover: "https://images.pexels.com/photos/8391471/pexels-photo-8391471.jpeg?auto=compress&cs=tinysrgb&w=800",
    amazonUrl: "https://www.amazon.com/dp/1069326798",
  },
];

export const BANNER_URL =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_f92f42ff-9198-4e11-98af-aab78d8bdf64/artifacts/cj23bdpi_grok-image-8ff9ce7e-d10a-4fd0-8088-be2fbf1cc94c.webp";

export const AUTHOR_PHOTO =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_stopa-books/artifacts/2tstj9jg_grok-image-1ed3c834-0fc3-4d68-bcb0-b0f33320891b.jpg";
